import React from 'react';
import styled from 'styled-components';

export interface DropdownItemProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  left?: React.ReactNode;
  handleClick?: Function;
}

export const StyledDropdownItemLeft = styled.div`
  display: flex;
  padding: 0 4px 0 0;
  color: ${({ theme }) => theme.colors.LABEL};
`;
const StyledDropdownItemContent = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 14px;
`;
export const StyledDropdownItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 4px 8px;
  margin: 2px 4px;
  border-radius: 4px;
  line-height: 1.5rem;
  gap: 16px;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s;
  color: ${({ theme }) => theme.colors.TITLE};

  :hover {
    background: rgba(0, 0, 0, 0.06);
  }
`;

const DropdownItemComponent = ({
  left,
  children,
  handleClick,
}: DropdownItemProps) => {
  return (
    <StyledDropdownItem onClick={() => handleClick && handleClick()}>
      {left && <StyledDropdownItemLeft>{left}</StyledDropdownItemLeft>}
      <StyledDropdownItemContent>{children}</StyledDropdownItemContent>
    </StyledDropdownItem>
  );
};

export default DropdownItemComponent;
